import { useLocale } from "@Src_main/localeProvider";
import React, { useEffect, useRef, useState } from "react";
import deFlag from "@Src_main/assets/images/flags/de.svg";
import itFlag from "@Src_main/assets/images/flags/it.svg";
import esFlag from "@Src_main/assets/images/flags/es.svg";
import frFlag from "@Src_main/assets/images/flags/fr.svg";
import enFlag from "@Src_main/assets/images/flags/en.svg";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import classes from "./languageSelector.module.scss";
const buttonImages = {
  de: deFlag,
  it: itFlag,
  es: esFlag,
  fr: frFlag,
  en: enFlag
};
const FlagCircle = _ref => {
  let {
    src,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      border: "1px solid #8f8a8aff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "4px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    draggable: false,
    onClick: onClick,
    style: {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      objectFit: "cover",
      display: "block",
      pointerEvents: 'auto',
      cursor: 'pointer'
    }
  })));
};
export const LanguageSelector = _ref2 => {
  let {
    topRight = false,
    inline = false
  } = _ref2;
  const {
    language,
    setLanguage,
    availableLanguages
  } = useLocale();
  const {
    isMobile
  } = useWindowSize();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const sortedLanguages = [language, ...availableLanguages.filter(l => l !== language).sort((a, b) => a.localeCompare(b))];
  useEffect(() => {
    if (!inline || !open) return;
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [inline, open]);
  function onClick(e, code) {
    if (open) {
      e.stopPropagation();
      setLanguage(code);
      setOpen(false);
    } else {
      setOpen(true);
    }
  }
  if (inline) {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: classes['language-selector-inline']
    }, /*#__PURE__*/React.createElement(FlagCircle, {
      src: buttonImages[language],
      onClick: e => onClick(e, language)
    }), open && /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes['language-selector-inline-dropdown'], " uk-box-shadow-medium")
    }, sortedLanguages.filter(l => l !== language).map(lang => /*#__PURE__*/React.createElement(FlagCircle, {
      key: lang,
      src: buttonImages[lang],
      onClick: e => onClick(e, lang)
    }))));
  }
  const selectorClass = isMobile ? topRight ? "".concat(classes['language-selector-mobile-top-right'], " uk-box-shadow-medium") : "".concat(classes['language-selector-mobile'], " uk-box-shadow-medium uk-position-fixed uk-position-bottom") : "".concat(classes['language-selector-desktop'], " uk-box-shadow-medium");
  return /*#__PURE__*/React.createElement("div", {
    id: "language-selector",
    className: selectorClass,
    style: {
      display: 'flex',
      flexDirection: 'column-reverse'
    }
  }, sortedLanguages.filter(x => open || x === language).map(lang => /*#__PURE__*/React.createElement(FlagCircle, {
    key: lang,
    src: buttonImages[lang],
    onClick: e => onClick(e, lang)
  })));
};